import React from 'react';

import Styled from './ProductImageStyled';

interface IProductImage {
  imageUrl: string;
}

const ProductImage = ({ imageUrl }: IProductImage): JSX.Element => {
  return (
    <Styled.ImageContainer>
      <img aria-hidden="true" data-testid="product-image" src={imageUrl} />
    </Styled.ImageContainer>
  );
};

export default ProductImage;
